import { BUTTON, CENTER, ALIGNMENT, COLUMN, HALF, WIDE, DESK, TABLET, MOBILE } from '.';
const COMPONENTS_DEFAULT_VALUES = {
  button: {
    type: '',
    style: BUTTON,
    size: '',
    alignment: `${BUTTON}--${CENTER} ${ALIGNMENT}`
  },
  column: {
    width: `${COLUMN}--${HALF}`
  },
  row: {
    width: WIDE,
    desk: DESK,
    tablet: TABLET,
    mobile: MOBILE
  }
};
export default COMPONENTS_DEFAULT_VALUES;
//# sourceMappingURL=componentsDefaultValues.js.map